/**
 * @module app.core
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { LookupService as CDLookupService } from 'app/cd/services/lookup-service';
import { apiCall } from 'app/shared/lib/api/api';
import { LookupService as CoreLookupService } from 'app/core/services/lookup-service';
import { deepClone } from 'app/shared/lib/utilities';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import * as Core from 'app/core/models/essette-api';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class EditMemberDemographics extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'reload' })
    protected memberDemographics: CD.MemberDemographics | null = null;

    protected genderIdentityOptions: Core.Gender[] = [];
    protected raceIdentityOptions: CD.Race[] = [];

    protected originalDemographics: CD.MemberDemographics = {};
    protected maxPronounsLength: number = 128;
    protected maxPreferredNameLength: number = 50;
    protected maxDisabilityLength: number = 200;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly coreLookupService: CoreLookupService,
        private readonly cdLookupService: CDLookupService,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.loadLookups();
    }


    ////****************** Functions ************************************************////
    public reload(): void {
        if(this.memberDemographics) {
            this.originalDemographics = deepClone(this.memberDemographics);
        }
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    // Information will be saved on the parent component, return if changes were made
    public async submit(): Promise<boolean> {
        return true;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadLookups(): Promise<void> {
        try {
            this.state.beginLoad();

            const options: Partial<IQueryLoadOptions> = {
                all: true
            };

            const fields = ['code', 'description'];

            const [genderIdentitiesResponse, raceIdentitiesResponse] = await Promise.all([
                this.coreLookupService.loadGenders(options, undefined, true, undefined, fields),
                this.cdLookupService.loadRaces(options, undefined, true, undefined, fields)
            ]);

            this.genderIdentityOptions = genderIdentitiesResponse.results;
            this.raceIdentityOptions = raceIdentitiesResponse.results;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
